import React from 'react';
import { Text } from '@chakra-ui/react';
import EpisodeMarquee from './EpisodeMarquee';
import episodesData from '../data/episodes.json';
import { normalizeEpisode } from '../utils/format';

// Ranked IDs only — order from Spotify all-time streams CSV
const RANKED_IDS = [
  '9d449e3e-de26-40e8-99e4-bc52f52aebf5',
  'b892bd21-6cdd-4711-a91a-2dd83734b6a6',
  '10ec1d76-1e59-4a1b-8f38-e4c4131a944f',
  'f7ea59de-3c95-41f0-81f1-5ff5ae554384',
  'd9de1436-4e53-4cbb-9441-c9c4aaa8611e',
  '774f1b18-fe42-4afb-8771-2407acac3a00',
  'c347e70a-8210-4b63-94b6-840cde30dc33',
  '22f2a3e6-b487-404a-b039-4295a252c32f',
  '1b80d375-d18c-411e-9afe-5691266bb9a6',
  'f3cd4b49-8455-41e7-ae3e-c130b70c359a',
];

const ALL_EPISODES = episodesData.seasons.flatMap(s => s.episodes);

const FAN_FAVOURITES = RANKED_IDS
  .map((id, i) => {
    const ep = ALL_EPISODES.find(e => e.id === id);
    if (!ep) return null;
    return { ...normalizeEpisode(ep), duration: ep.duration, rank: i + 1 };
  })
  .filter(Boolean);

const TopTenLabel = (
  <Text
    fontSize={{ base: "xs", md: "sm" }}
    color="whiteAlpha.500"
    fontStyle="italic"
  >
    All-time top 10
  </Text>
);

const FanFavourites = () => (
  <EpisodeMarquee
    heading="Fan Favourites"
    headingRight={TopTenLabel}
    episodes={FAN_FAVOURITES}
    trackName="fav"
    speedSec={45}
    mobileSpeedSec={36}
    py={{ base: 6, md: 8 }}
  />
);

export default FanFavourites;
